const INITIAL_STATE = {
  displayCategories: [],
  sponsors: [],
  carousels: [],
  contacts: [],
  videos: [],
  utilityDocuments: [],
  fetchingInitials: false,
  fetchingContacts: false,
  fetchingUtilityDocuments: false,
  menuLoaded: false,
  menuList: [],
  blocks: [],
  homeMenu: [],
  stats: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'GET_LAYOUT_MENU_REQUEST':
      return {
        ...state,
      };
    case 'GET_LAYOUT_MENU_SUCCESS':
      return {
        ...state,
        menuLoaded: true,
        menuList: action.payload,
      };
    case 'GET_LAYOUT_MENU_FAILURE':
      return {
        ...state,
      };
    case 'GET_INITIALS_REQUEST':
      return {
        ...state,
        fetchingInitials: true,
      };
    case 'GET_INITIALS_SUCCESS':
      return {
        ...state,
        fetchingInitials: false,
        displayCategories: action.payload.widgets,
        carousels: action.payload.carousels,
        sponsors: action.payload.sponsors,
        videos: action.payload.videos,
        blocks: action.payload.blocks,
        homeMenu: action.payload.homeMenu,
        stats: action.payload.stats,
      };
    case 'GET_INITIALS_FAILURE':
      return {
        ...state,
        fetchingInitials: false,
      };
    case 'GET_CONTACTS_REQUEST':
      return {
        ...state,
        fetchingContacts: true,
      };
    case 'GET_CONTACTS_SUCCESS':
      return {
        ...state,
        fetchingContacts: false,
        contacts: action.payload || [],
      };
    case 'GET_CONTACTS_FAILURE':
      return {
        ...state,
        fetchingContacts: false,
      };
    case 'GET_UTILITY_DOCUMENTS_REQUEST':
      return {
        ...state,
        fetchingUtilityDocuments: true,
      };
    case 'GET_UTILITY_DOCUMENTS_SUCCESS':
      return {
        ...state,
        fetchingUtilityDocuments: false,
        utilityDocuments: action.payload,
      };
    case 'GET_UTILITY_DOCUMENTS_FAILURE':
      return {
        ...state,
        fetchingUtilityDocuments: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/app.js